import { isEmpty } from "lodash";
import { getInitialDates } from "./DateHelper";
import { getObject } from "./StorageHelpers";
import { BOOLEAN_OPTIONS } from "./constants";

const getSessionFilters = (filterName) => {
    return getObject(filterName, true) || {};
};

const getInitialDateFilter = (
    datePropName = "createdAt",
    otherProps = {},
    duration = 1
) => {
    const { start, end } = getInitialDates(duration);
    return {
        [datePropName]: { startDate: start, endDate: end },
        ...otherProps,
    };
};

const getMappedFilters = (filters, booleanProps = [], numberProps = []) => {
    let newFilters = {};
    if (filters) {
        Object.keys(filters).forEach((key) => {
            if (
                filters[key] !== undefined &&
                !(isNaN(filters[key]) && isEmpty(filters[key]))
            ) {
                // since booleans are saved as strings, it needs to be checked explicitly
                if (booleanProps.includes(key)) {
                    newFilters[key] = filters[key] === BOOLEAN_OPTIONS.true;
                } else if (numberProps.includes(key)) {
                    newFilters[key] = Number(filters[key]);
                } else {
                    newFilters[key] = filters[key];
                }
            }
        });
    }
    return newFilters;
};

const toggleSort = (
    name,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection
) => {
    if (sortBy === name) {
        switch (sortDirection) {
            case "ASC":
                setSortBy(null);
                setSortDirection(null);
                break;
            case "DESC":
                setSortDirection("ASC");
                break;
            default:
                setSortDirection("DESC");
        }
    } else {
        setSortBy(name);
        setSortDirection("DESC");
    }
};

const getSortDirectionIcon = (headerName, sortBy, sortDirection) => {
    if (sortBy === headerName && sortDirection) {
        return sortDirection === "ASC"
            ? "fa-sort-alpha-up-alt"
            : "fa-sort-alpha-down-alt";
    } else return "fa-sort";
};

export {
    getSessionFilters,
    getInitialDateFilter,
    getMappedFilters,
    toggleSort,
    getSortDirectionIcon,
};
